import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ChooseCourseBoard from "./components/ChooseCourseBoard";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import EnrollmentSteps from "./components/EnrollmentSteps";
import SelectTeam from "./components/SelectTeam";
import { GraduationCap, LucideUsers, Sparkles, Target, TrendingUp } from "lucide-react";
import {
    getTrainingClassList
} from "../../../../redux/trainingclass/trainingClassState";
import {
    getTeamEnrollmentStat
} from "../../../../redux/overview/overviewState";
import { formatDateRange } from "utils";

const TeamUpskill = ({
    doSearch,
    pagination,
    recordList,
    getStats,
    recordStat,
}) => {

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedMembers, setSelectedMembers] = useState([]);

    const step1Done = !!selectedCourse;
    const step2Done = selectedMembers.length > 0;
    const step3Active = step1Done && step2Done;

    const courses = (recordList || []).map(item => ({
        id: item.tcl_id,
        title: item.tcl_title,
        subtitle: item.tcl_description,
        level: item.tcl_difficulty_name,
        category: item.course_cat_name,
        duration: item.tcl_duration,
        startDate: formatDateRange(item.tcl_schedule_date_from),
        instructor: item.instructor_name || "TBD", 
        enrolled: item.enrolled_count, 
        capacity: item.tcl_max_participant, 
    }));

    useEffect(() => {
        doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

    useEffect(() => {
        getStats();
    }, [getStats]);

    return (
        <div className="pt-6">
	    	<div className="grid grid-cols-1">
                <div className="space-y-6 ">
                    <SummaryHeader
                        title={"Upskill Your Team"}
                        icon={GraduationCap}
                        description={"Invest in growth. Empower your team with world-class training."}
                        color={"indigo"}
                        rightNav={
                                    step2Done && ( 
                                        <div className="flex flex-col items-center bg-white/20 border border-white/30 rounded-2xl p-4 min-w-[180px]">
                                        <Target size={32} className="mb-1" />
                                        <p className="text-[11px] text-purple-100">Selected for Enrollment</p>
                                        <p className="text-[24px] font-semibold text-white">
                                            {selectedMembers.length}
                                        </p>
                                        <p className="text-[11px] text-purple-200">
                                            {selectedMembers.length === 1 ? "team member" : "team members"}
                                        </p>
                                        </div>
                                    )
                                }
                    >
                        <div className="grid grid-cols-3 gap-4">
                            <SummaryItem
                                title="Available Courses"
                                icon={<Sparkles />}
                                display={recordStat?.available_courses}
                            />
                            <SummaryItem
                                title="Team Members"
                                icon={<LucideUsers/>}
                                display={recordStat?.team_members}
                            />
                            <SummaryItem
                                title="Total Enrollments"
                                icon={<TrendingUp/>}
                                display={recordStat?.total_enrollments}
                            />
                        </div>
                    </SummaryHeader>
                            
                    <EnrollmentSteps
                        step1Done={step1Done}
                        step2Done={step2Done}
                        step3Active={step3Active}
                        selectedCourse={selectedCourse}
                        selectedMembers={selectedMembers}
                    />
                        <>
                            <div className="flex flex-col space-y-6">
                                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 gradient-icon">
                                    <ChooseCourseBoard
                                        courses={courses}
                                        selectedCourse={selectedCourse}
                                        setSelectedCourse={setSelectedCourse}
                                        selectedMembers={selectedMembers}
                                        setSelectedMembers={setSelectedMembers}
                                    />      
                                    <div className="hidden lg:block">
                                        <SelectTeam
                                            selectedMembers={selectedMembers}
                                            setSelectedMembers={setSelectedMembers}
                                            selectedCourse={selectedCourse}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                </div>
            </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.trainingClass.trainingClassList?.items,
    recordStat: state.overview.teamEnrollmentStat?.data,
    filters: state.trainingClass.trainingClassList?.filters,
    pagination: state.trainingClass.trainingClassList?.pagination,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTrainingClassList(filters)),
    getStats: (data) => dispatch(getTeamEnrollmentStat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamUpskill);